// extracted by mini-css-extract-plugin
export default {"container":"Card_container__3E-a4","header":"Card_header__H8IWO","main":"Card_main__QdW7T"};